import type { SxProps } from '@mui/material/styles';
import { AmountField } from '@ovComponents/3-pattern/amountField/amountField';
import type { FieldRequiredType } from '@ovComponents/4-module/configurableOptionFields/basicField';
import { toAmountCents } from '@ovComponents/4-module/workflowCompletion/subSteps/utils/depositAmountRules';
import type { TransferContextData } from '@ovComponents/4-module/workflowCompletion/workflowTypes';
import { showsRequiredFieldError } from './depositFieldErrors';

export type DepositAmountProp = {
  amountCents?: number;
  label: string;
  requirement?: FieldRequiredType;
  focused: string[];
  onFocus: (field: string) => void;
  onChange: (value: Partial<TransferContextData>) => void;
  amountError: { hasError: boolean; errorMessage: string };
  disabled?: boolean;
  currency?: string;
  sx?: SxProps;
};

export const DepositAmount = ({
  amountCents,
  label,
  requirement,
  focused,
  onFocus,
  onChange,
  amountError,
  disabled,
  currency,
  sx,
}: DepositAmountProp) => (
  <AmountField
    disabled={disabled}
    useFormatAmountValueCents
    sx={sx}
    testId='deposit-form-amount-cents'
    label={label}
    setAmount={(e: any) =>
      onChange({
        amountCents: toAmountCents(e),
      })
    }
    amount={amountCents}
    onBlur={() => onFocus('amountCents')}
    error={
      showsRequiredFieldError({
        missing: !amountCents,
        field: 'amountCents',
        focused,
        requirement,
      }) ||
      (amountError.hasError && focused.includes('amountCents'))
    }
    errorText={amountError.hasError ? amountError.errorMessage : undefined}
    {...(currency ? { currency } : {})}
  />
);
